'use strict';
(function () {
  angular.module('pentaApp').factory('appRate.resource', service);

  service.$inject = ['$resource'];
  function service($resource) {
    return $resource('/progressiveApp/api/appRate');
  }
})();
